import { render, staticRenderFns } from "./AboutMeComponent.vue?vue&type=template&id=46c181ee"
import script from "./AboutMeComponent.vue?vue&type=script&lang=js"
export * from "./AboutMeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports